import { Ticker, Loader } from 'pixi.js';
import eventHub from '@/scripts/eventHub';
import Flower from './Flower';
import state from '../state';

class PowerUp extends Flower {
  constructor(parent, x, y = 0, id, textures) {
    super(parent, x, y, id, textures);

    this.shadow.texture = Loader.shared.resources['images/POWERUPS'].spritesheet.textures['powerup_shadow.png'];

    this.isPowerUp = true;
    this.powerUpDuration = 10; // in seconds
    this.end = 0;
    this.effects = new Map();
    this.effects.set('power', () => { this.powerEffect(); });
    this.effects.set('wide', () => { this.wideEffetc(); });
    this.effects.set('far', () => { this.farEffect(); });

    this.checkPowerup = () => { this.check(); };
  }

  catch() {
    // Play the power up effect
    if (state.hasActivePowerUp) {
      this.stopPowerup();
    }
    this.effects.get(this.id)();

    // Execute normal flower pop
    super.catch();
  }

  powerStart() {
    state.hasActivePowerUp = true;
    const start = new Date();
    this.end = start.setSeconds(start.getSeconds() + this.powerUpDuration);
    Ticker.shared.add(this.checkPowerup);
  }

  check() {
    const now = Date.now();
    const eta = this.end - now;
    const percent = eta / (this.powerUpDuration * 1000);
    state.powerUpProgress = percent;
    if (Date.now() > this.end) {
      this.stopPowerup();
    }
  }

  stopPowerup() {
    eventHub.$emit('stop-power-up');
    state.hasActivePowerUp = false;
    Ticker.shared.remove(this.checkPowerup);
    this.powerStop();
    this.wideStop();
    this.farStop();
  }

  powerEffect() {
    this.powerStart();
    state.poppingSpeed = 0.8; // Immediate
    eventHub.$emit('popping-speed-change');
    eventHub.$emit('ray-power');
  }

  wideEffetc() {
    this.powerStart();
    state.rayWide = 2;
    eventHub.$emit('ray-wide-change');
    eventHub.$emit('ray-wide');
  }

  farEffect() {
    this.powerStart();
    state.rayFar = 1.3;
    eventHub.$emit('ray-far-change');
    eventHub.$emit('ray-far');
  }

  powerStop() {
    state.poppingSpeed = 0.05;
    eventHub.$emit('popping-speed-change');
  }

  wideStop() {
    state.rayWide = 1;
    eventHub.$emit('ray-wide-change');
  }

  farStop() {
    state.rayFar = 1;
    eventHub.$emit('ray-far-change');
  }
}

export default PowerUp;
